import React from "react";
import { Route } from "react-router-dom";
import { useAuth } from "../auth/useAuth";
import Loader from "../components/Loader";
import Login from "./Login";

// A wrapper for <Route> that shows login screen if you're not yet authenticated.
export default function LoggedInRoute({
  children,
  ...rest
}: React.PropsWithChildren<any>) {
  const { auth, hasFetched, refresh } = useAuth();

  if (auth) {
    window.location.replace("/");
  }
  return (
    <Route
      {...rest}
      render={() =>
        hasFetched ? <Login checkAuth={refresh} /> : <Loader>Loading...</Loader>
      }
    />
  );
}
